import type { SearchParams } from '@/server/searchParams.ts';
import { API_NAME } from '@/app/components/search/common/apiTypes.ts';
import type { DynamicFiltersRequestPayload } from '@/app/api/search/dynamicfilters/createDynamicFiltersData.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { DynamicFiltersAPIResponse } from '../../utils/api/filtersAPIResponseTypes';
import { APIStatusEnum } from '../../common/reloadData/APIStatusEnum';
import type Form from '../Form';
import { type ControlProps } from '../Form';
import type { Localization } from '../../common/Localization';
import type { CuriosityParams } from '../../Curiosity';
import type { DynamicFiltersResponse } from '../../utils/api/dynamicFiltersResponseTypes';
import { createSearchParamsAccommodationFacilities } from './verticalFilters/Fields/getFacilitiesField/getFacilitiesFromQuery';
import clientAPICall from '../../common/clientAPICall.ts';
import { dynamicFiltersResponseDefault } from '../../common/reloadData/dynamicFiltersResponseDefault.ts';

type UpdateFiltersProps = {
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  getControls: (dynamicFiltersResponse: DynamicFiltersResponse) => ControlProps[];
  setDynamicFiltersResponse: React.Dispatch<React.SetStateAction<DynamicFiltersResponse | undefined>>;
  setIsWaiting?: React.Dispatch<React.SetStateAction<boolean>>;
  formRef: React.MutableRefObject<Form | undefined>;
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
};

export const updateFilters = async (props: UpdateFiltersProps) => {
  const {
    searchParams,
    searchInfoData,
    getControls,
    setDynamicFiltersResponse,
    setIsWaiting,
    formRef,
    commonData,
    localization,
  } = props;
  if (setIsWaiting) setIsWaiting(true);

  const searchParamsAccommodationFacilities = createSearchParamsAccommodationFacilities(searchParams);

  const dynamicFiltersPayload: DynamicFiltersRequestPayload = {
    searchParams: searchParamsAccommodationFacilities,
    searchInfoData,
    commonData,
    localization,
  };
  clientAPICall<DynamicFiltersRequestPayload, DynamicFiltersAPIResponse>({
    apiName: API_NAME.DYNAMIC_FILTERS,
    payload: dynamicFiltersPayload,
    commonData,
    traceParent: searchInfoData.searchTraceParent,
    defaultResponse: {
      ...dynamicFiltersResponseDefault,
      status: APIStatusEnum.ERROR,
    },
  })
    .then((response: DynamicFiltersAPIResponse | undefined): void => {
      if (
        (response && response.status === APIStatusEnum.RESYNC) ||
        (response && response.status === APIStatusEnum.WAIT)
      ) {
        setTimeout(() => {
          updateFilters(props);
        }, 1000);
      } else if (response?.filters) {
        setDynamicFiltersResponse(response.filters);
        setTimeout(() => {
          if (setIsWaiting) setIsWaiting(false);
          if (response.filters) {
            const controls = getControls(response.filters);
            formRef?.current?.updateControls(controls);
          }
        }, 300);
      }
    })
    .catch(() => {
      setDynamicFiltersResponse(undefined);
      if (setIsWaiting) setIsWaiting(false);
      // const controls = getControls();
      // formRef?.current?.updateControls(controls);
    });
};
